import React from 'react';
import logo from '../assets/tnp-bootcamp-logo.png';

const AuthLayout = ({ children }) => (
  <div className="auth">
    <aside className="auth-brand">
      <div className="brand-top">Automotive Training Network</div>
      <div>
        <h1><img src={logo} alt="TNP Bootcamp" className="auth-logo" /></h1>
        <p>Log every customer, move them down the line, and watch your team climb the board.</p>
      </div>
    </aside>
    <main className="auth-main">
      <div className="auth-form">{children}</div>
    </main>
  </div>
);

export const PASSWORD_RULES = [
  { label: 'A lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'An uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'A number or symbol', test: (p) => /[^a-zA-Z]/.test(p) },
  { label: '6 or more characters', test: (p) => p.length >= 6 },
  { label: 'Not the word "password"', test: (p) => p.length > 0 && !p.toUpperCase().includes('PASSWORD') },
];

export const passwordIsValid = (p) => PASSWORD_RULES.every((r) => r.test(p));

export const PasswordRules = ({ password }) => (
  <ul className="password-rules" aria-label="Password requirements">
    {PASSWORD_RULES.map((r) => (
      <li key={r.label} className={r.test(password) ? 'met' : ''}>{r.label}</li>
    ))}
  </ul>
);

export const apiErrorMessage = (e, fallback = 'Something went wrong. Try again.') =>
  (e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) || fallback;

export default AuthLayout;
